import LeadsBulkUploadApi from "../../services/api/LeadsBulkUpload";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in bulk upload leads actions:", err);
}

export const bulkUploadLeads = (file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(setLoader(true));
    let response = await LeadsBulkUploadApi.bulkUploadLeads(formData);
    dispatch(setLoader(false));
    if (response) {
      if (response.msg === "File Upload is successful") {
        dispatch(setStatus({ type: "success", message: response.msg }));
      } else {
        dispatch(
          setStatus({
            type: "error",
            message: response.msg,
          })
        );
      }
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};
